import { ChangeEvent, useState } from "react";
import { CustomMultiSelectComboboxOption } from "./CustomMultiSelectCombobox";

type UseCustomMultiSelectComboboxArgs = {
  selection: CustomMultiSelectComboboxOption[];
  options: CustomMultiSelectComboboxOption[];
  onSearch: (query: string) => void;
};

export const useCustomMultiSelectCombobox = ({
  selection,
  options,
  onSearch,
}: UseCustomMultiSelectComboboxArgs) => {
  const [query, setQuery] = useState("");

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    const nextQuery = event.target.value;
    setQuery(nextQuery);
    onSearch(nextQuery);
  };

  const selectedOptions = Array.from(
    new Map(selection.map((item) => [item.id, item])).values(),
  );

  const selectedIds = new Set(selectedOptions.map((item) => item.id));

  const unselectedOptions = options.filter(
    (option) => !selectedIds.has(option.id),
  );

  const getToggledValue = (option: CustomMultiSelectComboboxOption) => {
    const isSelected = selection.some((item) => item.id === option.id);
    if (isSelected) {
      return selection.filter((item) => item.id !== option.id);
    }
    return [...selection, option];
  };

  return {
    query,
    setQuery,
    selectedOptions,
    unselectedOptions,
    handleSearchChange,
    getToggledValue,
  };
};
